import React, { useState } from 'react';

interface ImagePreviewProps {
  src: string;
  alt?: string;
  text?: string;
  type?: 'image' | 'video';
  textClass?: string;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({
  src,
  alt,
  text,
  type = 'image',
  textClass,
}) => {
  const defaultImageUrl = '/assets/images/No_Image_Available.jpg';
  const [imageSrc, setImageSrc] = useState(src);
  const handleImageError = (fallbackUrl: string) => {
    setImageSrc(fallbackUrl);
  };

  return (
    <div className="flex items-center gap-3">
      {type === 'image' ? (
        <img
          src={imageSrc}
          alt={alt}
          onError={() => handleImageError(defaultImageUrl)}
          className="w-10 h-10 min-w-10 min-h-10 rounded object-contain"
        />
      ) : (
        <video className="w-10 h-10 min-w-10 min-h-10 rounded object-cover">
          <source src={src} />
        </video>
      )}
      {text && (
        <span className={`font-medium truncate w-[150px] ${textClass}`}>
          {text}
        </span>
      )}
    </div>
  );
};

export default ImagePreview;
